export default "__VITE_ASSET__BAgvS5iz__"